import * as React from 'react';
import { Query, Mutation } from 'react-apollo';
import { RouteComponentProps } from 'react-router-dom';
import GetContactUs from '../../graphql/queries/GetContactUs';
import ContactUsForm from '../../forms/contactUs/ContactUsForm';
import UpdateContactUs from '../../graphql/mutations/UpdateContactUs';
import GetAllContactUs from '../../graphql/queries/GetAllContactUs';

interface RouteParams {
  id: string;
}

const EditContactUs: React.FC<RouteComponentProps<RouteParams>> = ({ match, history }) => {
  const id = match.params.id;

  return (
    <Query query={GetContactUs} variables={{ id }}>
      {({ loading: queryLoading, error: queryError, data }) => {
        if (queryLoading) {
          return <div>Loading...</div>;
        }
        if (queryError) {
          return <div>Error loading contact</div>;
        }

        return (
          <Mutation
            mutation={UpdateContactUs}
            refetchQueries={[{ query: GetAllContactUs }]}
            onCompleted={() => history.push('/contact-us')}
          >
            {(updateContactUs, { loading: mutationLoading, error: mutationError }) => (
              <ContactUsForm
                initialValues={data.contactus}
                mutation={(values) =>
                  updateContactUs({
                    variables: {
                      updateContactUsId: id,
                      data: {
                        name: values.name,
                        number: values.number,
                        email: values.email,
                        status: values.status.value,
                      },
                    },
                  })
                }
                loading={mutationLoading}
                error={mutationError}
                formType="edit"
              />
            )}
          </Mutation>
        );
      }}
    </Query>
  );
};

export default EditContactUs;



// WEBPACK FOOTER //
// ./src/containers/contactUs/EditContactUs.tsx